"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var formik_1 = require("formik");
var asg_1 = require("@alinta-digital/asg");
var view_1 = require("./view");
var types_1 = require("./types");
var myaccount_frontend_shared_1 = require("@alinta-digital/myaccount-frontend-shared");
var PaymentForm = function (props) {
    var _a, _b, _c;
    (0, myaccount_frontend_shared_1.useAnalyticsLoadV2)(props.ga, 'load.0.paymentpage', ((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.web.payment');
    (0, myaccount_frontend_shared_1.useAnalyticsLoadV2)(props.ga, 'load.0.', ((_b = props.ga) === null || _b === void 0 ? void 0 : _b.eventName) === 'process.payment');
    var paymentDetails = props.paymentDetails, paymentSummary = props.paymentSummary, paymentConfirmation = props.paymentConfirmation, isUnAuthenticated = props.isUnAuthenticated, savedPayment = props.savedPayment;
    var paymentDetailsOnSubmit = paymentDetails.onSubmit, onValidateAccountNumber = paymentDetails.onValidateAccountNumber;
    var _d = (0, react_1.useState)({
        code: 0,
        expiryMonth: '',
        expiryYear: '',
        last4: '',
        token: ''
    }), cardResult = _d[0], setCardResult = _d[1];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _e = (0, react_1.useState)(types_1.PaymentCardType.EMPTY), cardType = _e[0], setCardType = _e[1];
    var newPaymentDetialsProps = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, paymentDetails), { onSubmit: function (cardResult, cardType) {
            setCardType(cardType);
            setCardResult(cardResult);
            paymentDetailsOnSubmit();
        }, isUnAuthenticated: isUnAuthenticated, savedPayment: savedPayment });
    var accountDetails = paymentDetails.accountDetails;
    var newPaymentSummaryProps = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, paymentSummary), { accountDetails: accountDetails, reviewPayment: {
            paymentToken: cardResult.token,
            cardType: cardType,
            cardNumber: cardResult.last4,
            cardExpiryMonth: cardResult.expiryMonth,
            cardExpiryYear: cardResult.expiryYear,
            name: cardResult.name,
            savePaymentToken: cardResult.savePaymentToken
        }, isUnAuthenticated: isUnAuthenticated, savedPayment: savedPayment, savedPaymentId: cardResult.savedPaymentId });
    if (isUnAuthenticated) {
        delete newPaymentSummaryProps.accountDetails;
    }
    var getPaymentAmount = function () {
        var _a;
        if (!isUnAuthenticated && accountDetails) {
            return accountDetails.credit ? '' : accountDetails.accountBalance;
        }
        return ((_a = props.paymentPrefilledDetails) === null || _a === void 0 ? void 0 : _a.paymentAmount) || '';
    };
    var initialValues = {
        paymentDetails: {
            paymentAmount: getPaymentAmount(),
            cardName: '',
            accountNumber: (_c = props.paymentPrefilledDetails) === null || _c === void 0 ? void 0 : _c.accountNumber,
            hasSavePaymentMethod: false,
            savedPaymentId: '',
            paymentTab: types_1.PaymentTab.CreditOrDebitCard
        }
    };
    var onValidate = (0, react_1.useCallback)(function (values) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
        var err_1;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, , 8]);
                    if (!(values.paymentDetails.paymentTab === types_1.PaymentTab.PayPal)) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, formik_1.validateYupSchema)(values, view_1.paypalMethodValidation, false, {
                            onValidateAccountNumber: onValidateAccountNumber,
                            isUnAuthenticated: isUnAuthenticated,
                            savedPayment: savedPayment
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, {}];
                case 2:
                    if (!(savedPayment && values.paymentDetails.savedPaymentId !== '')) return [3 /*break*/, 4];
                    return [4 /*yield*/, (0, formik_1.validateYupSchema)(values, view_1.savedPaymentMethodValidation, false, {
                            isUnAuthenticated: isUnAuthenticated,
                            savedPayment: savedPayment
                        })];
                case 3:
                    _a.sent();
                    return [2 /*return*/, {}];
                case 4: return [4 /*yield*/, (0, formik_1.validateYupSchema)(values, view_1.paymentDetailsSchema, false, {
                        onValidateAccountNumber: onValidateAccountNumber,
                        isUnAuthenticated: isUnAuthenticated,
                        savedPayment: savedPayment
                    })];
                case 5:
                    _a.sent();
                    return [2 /*return*/, {}];
                case 6: return [3 /*break*/, 8];
                case 7:
                    err_1 = _a.sent();
                    return [2 /*return*/, (0, formik_1.yupToFormErrors)(err_1)];
                case 8: return [2 /*return*/];
            }
        });
    }); }, [isUnAuthenticated, onValidateAccountNumber, savedPayment]);
    var urlParams = new URLSearchParams(window.location.search);
    var isPaypalResultPage = (urlParams === null || urlParams === void 0 ? void 0 : urlParams.has('SessionID')) && urlParams.has('SST');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(asg_1.StepsConsumer, { stepCount: 3 }, function (_a) {
            var steps = _a.steps;
            return (react_1.default.createElement(asg_1.Box, { width: "100%", maxWidth: "864px", margin: "0 auto" },
                react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, onSubmit: function () { return undefined; }, validate: onValidate }, function (state) { return (react_1.default.createElement(formik_1.Form, null,
                    steps.step1.isEdit && react_1.default.createElement(view_1.PaymentDetails, (0, tslib_1.__assign)({}, newPaymentDetialsProps)),
                    steps.step2.isEdit && react_1.default.createElement(view_1.PaymentSummary, (0, tslib_1.__assign)({}, newPaymentSummaryProps)),
                    steps.step3.isEdit ? (isUnAuthenticated ? (react_1.default.createElement(view_1.PaymentConfirmationUnAuth, (0, tslib_1.__assign)({}, paymentConfirmation, { paymentType: isPaypalResultPage || state.values.paymentDetails.paymentTab === types_1.PaymentTab.PayPal
                            ? 'paypal'
                            : 'card' }))) : (react_1.default.createElement(view_1.PaymentConfirmation, (0, tslib_1.__assign)({}, paymentConfirmation, { paymentType: isPaypalResultPage || state.values.paymentDetails.paymentTab === types_1.PaymentTab.PayPal
                            ? 'paypal'
                            : 'card' })))) : (react_1.default.createElement(react_1.default.Fragment, null)))); })));
        })));
};
exports.default = PaymentForm;
//# sourceMappingURL=PaymentForm.js.map